import React, { FunctionComponent, useEffect } from 'react';
import { Link } from 'react-router-dom';
import DashboardPageLayout from '../../layouts/dashboard/dashboardPageLayout';
import * as plausible from '../../services/plausible';

const NotFoundPage: FunctionComponent = () => {
  useEffect(() => {
    plausible.trackEvent('400', {
      path: window?.location?.pathname,
    });
  }, []);

  return (
    <DashboardPageLayout>
      <main className="flex-1 relative overflow-y-auto bg-white focus:outline-hidden">
        <div className="py-16">
          <div className="text-center">
            <h2 className="mt-2 text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
              Page not found.
            </h2>
            <p className="mt-2 text-base text-gray-500">
              Sorry, we couldn’t find the page you’re looking for.
            </p>
            <div className="mt-6">
              <Link
                to="/dashboard"
                className="text-base font-medium text-secondary hover:text-secondary-dark"
              >
                Go back home<span aria-hidden="true"> &rarr;</span>
              </Link>
            </div>
          </div>
        </div>
      </main>
    </DashboardPageLayout>
  );
};

export default NotFoundPage;
